// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { calipers16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-calipers': IconCalipers;
    }
}

/**
 * The icon component for the 'calipers' icon
 */
export class IconCalipers extends IconSvg {
    public constructor() {
        super(calipers16X16);
    }
}

registerIconSvg('icon-calipers', IconCalipers);
export const iconCalipersTag = 'nimble-icon-calipers';
